import * as React from "react";
import { forwardRef } from "react";
const SvgEqual = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-equal-icon lucide-equal", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 5, x2: 19, y1: 9, y2: 9 }), /* @__PURE__ */ React.createElement("line", { x1: 5, x2: 19, y1: 15, y2: 15 }));
const ForwardRef = forwardRef(SvgEqual);
export { ForwardRef as ReactComponent };
